import React from 'react'

type Props = {
  children?: any
  className?: string
  classNameTooltip?: string
  textTooltip?: string
  handleEvent?: any
}
const TooltipModal: React.FC<Props> = ({
  children,
  textTooltip,
  className,
  classNameTooltip,
  handleEvent,
}) => {
  return children && textTooltip ? (
    <div className={`tooltip-modal ${className}`}>
      {children}
      <div className={`tooltip-modal__text ${classNameTooltip}`} onClick={handleEvent}>
        {textTooltip.split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </div>
    </div>
  ) : null
}

export {TooltipModal}
